export const AddCartDetailsShimmer = () => {
  return (
    <div className="flex flex-col min-h-[100dvh] bg-bodyBgColor animate-pulse">
      <div className="flex-1 mb-3 relative md:max-w-7xl mx-auto px-4 sm:px-4 2xl:px-0 lg:px-8 pt-5 md:pb-4 pb-0">
        <div >
          {/* Left Panel - Cart Items */}
          <div className="w-full lg:w-2/3 space-y-4">
            {Array.from({ length: 3 }).map((_, idx) => (
              <div
                key={idx}
                className="flex flex-col md:grid md:grid-cols-6 gap-3 md:gap-4 items-center bg-white p-4 rounded"
              >
                <div className="flex gap-3 items-center col-span-3 w-full">
                  <div className="w-4 h-4 bg-gray-300 rounded"></div>
                  <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gray-300 rounded"></div>
                  <div className="flex-1 space-y-2">
                    <div className="h-4 w-3/4 bg-gray-300 rounded"></div>
                    <div className="h-3 w-1/2 bg-gray-300 rounded"></div>
                  </div>
                </div>

                <div className="hidden md:flex justify-center items-center col-span-1">
                  <div className="h-4 w-16 bg-gray-300 rounded"></div>
                </div>

                <div className="hidden md:flex items-center justify-center space-x-2 col-span-1">
                  <div className="w-8 h-8 bg-gray-300 rounded"></div>
                  <div className="w-8 h-4 bg-gray-300 rounded"></div>
                  <div className="w-8 h-8 bg-gray-300 rounded"></div>
                </div>

                <div className="flex items-center justify-center col-span-1">
                  <div className="w-5 h-5 bg-gray-300 rounded"></div>
                </div>
              </div>
            ))}
          </div>

          {/* Right Panel - Order Summary */}
          <div className="w-full lg:w-1/3 space-y-4">
            <div className="bg-white p-5 rounded space-y-3">
              <div className="h-6 w-1/3 bg-gray-300 rounded"></div>
              <div className="space-y-2">
                <div className="h-4 w-full bg-gray-300 rounded"></div>
                <div className="h-4 w-full bg-gray-300 rounded"></div>
                <div className="h-6 w-full bg-gray-300 rounded"></div>
              </div>
              <div className="h-10 w-full bg-gray-300 rounded mt-2"></div>
            </div>

            <div className="bg-white p-5 rounded space-y-3">
              <div className="h-6 w-1/2 bg-gray-300 rounded"></div>
              <div className="h-4 w-full bg-gray-300 rounded"></div>
              <div className="h-4 w-full bg-gray-300 rounded"></div>
              <div className="h-10 w-full bg-gray-300 rounded mt-2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
